function isToggleActive(toggle) {
	const toggles = getToggles();
	return toggles[toggle] === true;
}

function getToggles() {
	const moduleContainer = document.querySelector(".combo_combolist-container");
	const rawToggles = moduleContainer?.dataset.toggles || "{}";
	try {
		return JSON.parse(rawToggles);
	} catch {
		return {};
	}
}

export default isToggleActive;
